// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"a3779297","285":"734855fc","323":"a9654120","332":"6392b6e1","757":"077b1a14","850":"fdd514f7"}[chunkId] + ".chunk.js";
};